<template>
    <div class="h-screen app">
        <component :is="layout || 'div'" class="appcomponent">
            <router-view :key="$route.fullPath" />
        </component>
        <PrimaryNotification ref="primaryNotification" />
        <SecondaryNotification ref="secondaryNotification" />
        <DynamicDialog />
        <ConfirmDialog />
        <Toast @close="onToastRemoved" />
        <ProcessingOverlay />
        <!-- <VueQueryDevtools /> -->
    </div>
</template>

<script setup>
import { provide, shallowRef, onMounted } from "vue";
import { useRouter } from "vue-router";

import layouts from "@/layouts/layouts.js";
import ConfirmDialog from "primevue/confirmdialog";
import Toast from "primevue/toast";
import DynamicDialog from "primevue/dynamicdialog";
import ProcessingOverlay from "@/components/ProcessingOverlay.vue";
import { onToastRemoved } from "@/composables/useStreamLimitWarning";

// Connect to the backend to see if it's up
import { useCorridorStatus } from "@/composables/useCorridorStatus.js";
const { execute: checkCorridorStatus } = useCorridorStatus();

const router = useRouter();

const layout = shallowRef("div");

router.afterEach((to) => {
    layout.value = layouts[to.meta.layout] || "div";
});

provide("app:layout", layout);

// Electron shell integration: auto-start/stop recording when an active incident
// exists in any community, and feed the shell the recording context the vault
// backend needs. A complete no-op outside the Electron desktop shell.
import { useElectronIncidentBridge } from "@/services/electronIncidentBridge";
useElectronIncidentBridge();

onMounted(async () => {
    console.log(import.meta.env.VITE_GIT_COMMIT_HASH);
    console.log(import.meta.env.VITE_GIT_COMMIT_DATE);

    // Is the system up?
    checkCorridorStatus({
        onSuccess: () => {
            console.log("corridor is up");
        },
        onError: () => {
            // There was an error
            console.log("checkCorridorStatus onError");
        },
    });
});
</script>
